import React from 'react'
import { useNavigate } from 'react-router-dom'
import '../styles/compsStyles/longtype.css'
import { BsThreeDotsVertical } from 'react-icons/bs';
import { HiOutlinePhotograph } from 'react-icons/hi';
import UserAvatar from './userAvatar';
import PlaylistSave from './playlistSave'

const LongType = props => {
  const navigate = useNavigate()
  const goChannel = (event) => {
    if (event) event.stopPropagation()
    if (props.communityid) navigate(`/community/${props.communityid}`)
    else if (props.userid) navigate(`/@${props.userid}`)
  }
  const formatViews = (views) => {
    const n = Number(views);
    if (Number.isNaN(n)) return views;
    if (n >= 1000000) return `${(n / 1000000).toFixed(1).replace(/\.0$/, '')}M`;
    if (n >= 1000) return `${(n / 1000).toFixed(1).replace(/\.0$/, '')}K`;
    return n;
  };
  const photo = Boolean(props.photo);
  const photoCount = Number(props.photoCount || 0);

  return (
    <article className={`${props.setVideo ? 'longTypeSetvideo' : 'longType'}${props.featured && !photo ? ' longType--featured' : ''}${props.recommend ? ' longType--recommend' : ''}${photo ? ' longType--photo' : ''}`}>
      <div className="longTypeThumbWrap">
        <img
          className="longTypeThumb"
          alt={`iciskare ${props.title}`}
          src={`/api/uploads/${props.thumbnail}`}
          loading="lazy"
          decoding="async"
        />
        {photo ? (
          <>
            <span className="longTypePhotoBadge"><HiOutlinePhotograph /> Post</span>
            {photoCount > 1 ? <span className="longTypePhotoStack">{photoCount}</span> : null}
          </>
        ) : null}
      </div>

      <div className="longTypeInfo">
        <UserAvatar
          className="longTypeUserImg"
          alt={`iciskare ${props.email}`}
          name={props.email}
          userId={props.userid}
          src={props.userImg}
          onClick={goChannel}
        />

        <div className="longTypeMeta">
          <h3 className="longTypeTitle">{props.title}</h3>
          {props.recommend ? (
            <>
              <p className="longTypeChannel" onClick={goChannel}>{props.communityid ? props.email : props.email}</p>
              <p className="longTypeSub">
                {formatViews(props.views)} views • {props.date}
              </p>
            </>
          ) : (
            <p className="longTypeSub">
              <span onClick={goChannel}>{props.email}</span> • {photo ? 'Photo' : `${formatViews(props.views)} views`} • {props.date}
            </p>
          )}
        </div>

        <PlaylistSave
          className="longTypeMenu"
          icon={<BsThreeDotsVertical />}
          post={{
            id: props.postId,
            title: props.title,
            thumbnail: props.thumbnail,
            type: photo ? 'i' : 'l',
            image: props.thumbnail
          }}
        />

        {props.history && (
          <button type="button" className="longTypeDelete" onClick={props.thing}>
            delete
          </button>
        )}
      </div>

    </article>
  )
}

export default LongType;
